module.exports = __webpack_public_path__ + "assets/img/activity.2c0aca81.png";